var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFastForward3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.559,
    height: 19.855,
    viewBox: "0 0 14.559 19.855",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fast-forward",
    transform: "translate(14.559) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_57",
    "data-name": "Groupe 57",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_56",
    "data-name": "Groupe 56",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_40",
    "data-name": "Trac\\xE9 40",
    d: "M208.17,70.85l5.956-6.618a.662.662,0,0,1,.492-.22h3.971a.661.661,0,0,1,.492,1.1l-5.558,6.175,5.558,6.174a.662.662,0,0,1-.492,1.105h-3.971a.671.671,0,0,1-.492-.218l-5.956-6.618A.662.662,0,0,1,208.17,70.85Z",
    transform: "translate(-208 -64.013)",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_59",
    "data-name": "Groupe 59",
    transform: "translate(8.604 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_58",
    "data-name": "Groupe 58",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_41",
    "data-name": "Trac\\xE9 41",
    d: "M.17,70.85l5.956-6.618a.662.662,0,0,1,.492-.22h3.971a.661.661,0,0,1,.492,1.1L5.524,71.292l5.558,6.174a.662.662,0,0,1-.492,1.105H6.618a.671.671,0,0,1-.492-.218L.17,71.736A.662.662,0,0,1,.17,70.85Z",
    transform: "translate(0 -64.013)",
    fill: "#707070"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastForward3);
export default __webpack_public_path__ + "static/media/fast-forward3.bf7627cb6ea3dbe23c3cc49c5d894069.svg";
export { ForwardRef as ReactComponent };